import createMultiParamFromArray from "@/utils/multi-param-from-array";
import isArray from "lodash/isArray";

export default function createMultiParamFromObject(obj = {}) {
  let keys;
  if (typeof obj === "object" && obj !== null) keys = Object.keys(obj);
  else return "";
  if (keys.length < 1) return "";
  return keys.reduce((acc, key, i, arr) => {
    if (isArray(obj[key]))
      return `${acc}${createMultiParamFromArray(key, obj[key])}${
        i < arr.length - 1 ? "&" : ""
      }`;
    return `${acc}${key}=${obj[key].toString().replace(/\+/g, "%2b")}${
      i < arr.length - 1 ? "&" : ""
    }`;
  }, "");
}
